<div class="features-area pb-24">
    <div class="container">
        <!-- 🔎 Buscador -->
        <div class="toolbar">
            <div class="search">
                <i class="fas fa-search" aria-hidden="true"></i>
                <input
                    type="text"
                    [formControl]="searchCtrl"
                    placeholder="Buscar: centros, sedes, órdenes, afiliados..."
                    aria-label="Buscar opciones"
                />
            </div>
            <div class="count" *ngIf="filtered?.length !== items.length">
                {{ filtered.length }} resultado{{
                    filtered.length === 1 ? "" : "s"
                }}
            </div>
        </div>

        <!-- 🧩 Grilla compacta y fluida -->
        <div class="grid">
            <div
                class="card"
                *ngFor="let it of filtered; trackBy: trackByTitle"
            >
                <div class="icon" [style.color]="it.color">
                    <i [class]="it.icon" aria-hidden="true"></i>
                </div>
                <div class="title">{{ it.title }}</div>
                <div class="desc">{{ it.desc }}</div>
                <a class="btn-ghost" [routerLink]="it.route">
                    Abrir <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </div>
</div>
